import {Component, ViewEncapsulation} from '@angular/core';
import {
  BookingFormFieldsCssClasses,
  BookingFormFieldTypeEnum,
  SurveyAdditionalFieldsEnum,
} from '../../enums/booking-enums';
import {BookingV2DataService} from '../../services/booking-v2-data.service';
import {BookingV2SurveyService} from '../../services/booking-v2-survey.service';
import {BookingMetadata} from '../../types/booking-metadata';

@Component({
  selector: 'app-survey-v2',
  templateUrl: './survey-v2.component.html',
  styleUrls: ['./survey-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SurveyV2Component {
  public fieldTypeEnum = BookingFormFieldTypeEnum;
  public surveyAdditionalFieldsEnum = SurveyAdditionalFieldsEnum;

  constructor(
    public bookingData: BookingV2DataService,
    public bookingSurvey: BookingV2SurveyService,
  ) {}

  public trackByMethod(i: number, el: BookingMetadata) {
    return el ? el.key : null;
  }

  public preventNonNumeric(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', 'Home', 'End'];
    if (allowedKeys.includes(event.key)) {
      return;
    }
    if (event.key === ' ' || !/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  public preventNonNumericPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData.getData('text');
    if (!clipboardData.match(/^[0-9]*$/)) {
      event.preventDefault();
    }
  }

  public handleScroll(event: WheelEvent) {
    (event.target as HTMLElement).blur();
  }

  public getCssClassNameByFieldType(fieldType: string): string {
    switch (fieldType) {
      case BookingFormFieldTypeEnum.TEXT:
        return BookingFormFieldsCssClasses.HALF;
      case BookingFormFieldTypeEnum.RADIO:
        return BookingFormFieldsCssClasses.HALF;
      case BookingFormFieldTypeEnum.BOOLEAN:
        return BookingFormFieldsCssClasses.HALF;
      case BookingFormFieldTypeEnum.MULTISELECT:
        return BookingFormFieldsCssClasses.HALF;
      case BookingFormFieldTypeEnum.TEXTAREA:
        return BookingFormFieldsCssClasses.FULL;
      case BookingFormFieldTypeEnum.DATEPICKER:
        return BookingFormFieldsCssClasses.HALF;
      case BookingFormFieldTypeEnum.PERSONAL_NUMBER:
        return BookingFormFieldsCssClasses.FULL;
      case BookingFormFieldTypeEnum.PHONE_NUMBER:
        return BookingFormFieldsCssClasses.HALF;
      default:
        return BookingFormFieldsCssClasses.FULL;
    }
  }

  public onBlur(key: string) {
    const control = this.bookingSurvey.surveyForm.controls[key];
    control.setValue(control.value.trim());
  }
}
